import { Button, Tooltip, useMatches } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { IconTags } from "@/components/icons";

import type { FC } from "react";

interface Props {
  canCompareByPlan: boolean;
  open: () => void;
  totalCars: number;
}

const CompareButton: FC<Props> = ({ canCompareByPlan, open, totalCars }) => {
  const { t } = useTranslation();
  const isMobile = useMatches({ base: true, md: false });

  return (
    <>
      <Tooltip
        label={t("plans.contentLocker.upgradeToAccess")}
        disabled={canCompareByPlan}
        withArrow
        events={{ hover: true, focus: true, touch: true }}
        position="top"
        offset={6}
        maw={300}
        openDelay={100}
        multiline
      >
        <Button
          display={isMobile ? "none" : "inherit"}
          onClick={open}
          leftSection={<IconTags />}
          disabled={totalCars < 2 || !canCompareByPlan}
          aria-label={t("garage.compare")}
        >
          {t("garage.compare")}
        </Button>
      </Tooltip>

      <Tooltip
        label={t("plans.contentLocker.upgradeToAccess")}
        disabled={canCompareByPlan}
        withArrow
        events={{ hover: true, focus: true, touch: true }}
        position="top"
        offset={-8}
        maw={300}
        openDelay={100}
        multiline
      >
        <Button
          px="xs"
          onClick={open}
          display={!isMobile ? "none" : "inherit"}
          disabled={totalCars < 2 || !canCompareByPlan}
        >
          <IconTags />
        </Button>
      </Tooltip>
    </>
  );
};

export default CompareButton;
